// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delivery-content[data-v-79fcb9bc]{max-width:900px}ul[data-v-79fcb9bc],ol[data-v-79fcb9bc]{padding-left:20px}", ""]);
// Exports
module.exports = exports;
